"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Banda App API
 * The API for the Banda App
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewModelControllerApi = exports.ViewModelControllerApiFactory = exports.ViewModelControllerApiFp = exports.ViewModelControllerApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * ViewModelControllerApi - axios parameter creator
 * @export
 */
const ViewModelControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsEntityFieldsGet: (entity, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entity' is not null or undefined
            (0, common_1.assertParamExists)('apiViewModelsEntityFieldsGet', 'entity', entity);
            const localVarPath = `/api/viewModels/{entity}/fields`
                .replace(`{${"entity"}}`, encodeURIComponent(String(entity)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [userId]
         * @param {boolean} [publicOnly]
         * @param {boolean} [pastOnly]
         * @param {boolean} [onlyFutureEvents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsEventsGet: (userId, publicOnly, pastOnly, onlyFutureEvents, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/api/viewModels/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (publicOnly !== undefined) {
                localVarQueryParameter['publicOnly'] = publicOnly;
            }
            if (pastOnly !== undefined) {
                localVarQueryParameter['pastOnly'] = pastOnly;
            }
            if (onlyFutureEvents !== undefined) {
                localVarQueryParameter['onlyFutureEvents'] = onlyFutureEvents;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsUserEventsGet: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            (0, common_1.assertParamExists)('apiViewModelsUserEventsGet', 'userId', userId);
            const localVarPath = `/api/viewModels/userEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} id
         * @param {number} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsUserEventsIdGet: (id, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            (0, common_1.assertParamExists)('apiViewModelsUserEventsIdGet', 'id', id);
            const localVarPath = `/api/viewModels/userEvents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.ViewModelControllerApiAxiosParamCreator = ViewModelControllerApiAxiosParamCreator;
/**
 * ViewModelControllerApi - functional programming interface
 * @export
 */
const ViewModelControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.ViewModelControllerApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsEntityFieldsGet(entity, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiViewModelsEntityFieldsGet(entity, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [userId]
         * @param {boolean} [publicOnly]
         * @param {boolean} [pastOnly]
         * @param {boolean} [onlyFutureEvents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsEventsGet(userId, publicOnly, pastOnly, onlyFutureEvents, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiViewModelsEventsGet(userId, publicOnly, pastOnly, onlyFutureEvents, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsUserEventsGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiViewModelsUserEventsGet(userId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} id
         * @param {number} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsUserEventsIdGet(id, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.apiViewModelsUserEventsIdGet(id, userId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.ViewModelControllerApiFp = ViewModelControllerApiFp;
/**
 * ViewModelControllerApi - factory interface
 * @export
 */
const ViewModelControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.ViewModelControllerApiFp)(configuration);
    return {
        /**
         *
         * @param {string} entity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsEntityFieldsGet(entity, options) {
            return localVarFp.apiViewModelsEntityFieldsGet(entity, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [userId]
         * @param {boolean} [publicOnly]
         * @param {boolean} [pastOnly]
         * @param {boolean} [onlyFutureEvents]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsEventsGet(userId, publicOnly, pastOnly, onlyFutureEvents, options) {
            return localVarFp.apiViewModelsEventsGet(userId, publicOnly, pastOnly, onlyFutureEvents, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsUserEventsGet(userId, options) {
            return localVarFp.apiViewModelsUserEventsGet(userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} id
         * @param {number} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiViewModelsUserEventsIdGet(id, userId, options) {
            return localVarFp.apiViewModelsUserEventsIdGet(id, userId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.ViewModelControllerApiFactory = ViewModelControllerApiFactory;
/**
 * ViewModelControllerApi - object-oriented interface
 * @export
 * @class ViewModelControllerApi
 * @extends {BaseAPI}
 */
class ViewModelControllerApi extends base_1.BaseAPI {
    /**
     *
     * @param {string} entity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewModelControllerApi
     */
    apiViewModelsEntityFieldsGet(entity, options) {
        return (0, exports.ViewModelControllerApiFp)(this.configuration).apiViewModelsEntityFieldsGet(entity, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [userId]
     * @param {boolean} [publicOnly]
     * @param {boolean} [pastOnly]
     * @param {boolean} [onlyFutureEvents]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewModelControllerApi
     */
    apiViewModelsEventsGet(userId, publicOnly, pastOnly, onlyFutureEvents, options) {
        return (0, exports.ViewModelControllerApiFp)(this.configuration).apiViewModelsEventsGet(userId, publicOnly, pastOnly, onlyFutureEvents, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewModelControllerApi
     */
    apiViewModelsUserEventsGet(userId, options) {
        return (0, exports.ViewModelControllerApiFp)(this.configuration).apiViewModelsUserEventsGet(userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} id
     * @param {number} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ViewModelControllerApi
     */
    apiViewModelsUserEventsIdGet(id, userId, options) {
        return (0, exports.ViewModelControllerApiFp)(this.configuration).apiViewModelsUserEventsIdGet(id, userId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.ViewModelControllerApi = ViewModelControllerApi;
